/**
 * Makes a request to reorder the dataset.
 */
var handleError = function (err) {
    console.error(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Network Error'
    }));
  };

export default async function reorderData(orderid) {
    
  try {
    const url = process.env.REACT_APP_FIND_API + '/order/reorder?orderid=' + encodeURIComponent(orderid);
    const res = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res || !res.ok) throw new Error('Failed to reorder data');
    return true;
  } catch (err) {
    handleError(err);
    return 0;
  }
}